module.exports = __webpack_public_path__ + "static/media/user-bg-icon.938e8205.svg";